module.exports = __webpack_public_path__ + "static/media/8OLA20.486a248c.jpg";